export default {
  'Header.Link': ({ property }) => {
    window.open(property?.website, "_blank");
  }
};
